export const FETCH_LANGUAGE_REQ = 'FETCH_LANGUAGE_REQ'

